(function fieldAnimations($, Drupal) {
  Drupal.behaviors.wwf_field_animation = {
    attach() {
      function handleAnimation() {
        $(".field-animation input").each((i, e) => {
          if (e === document.activeElement || $(e).val().length !== 0) {
            const inputId = $(e).attr("id");
            $(`label[for=${inputId}]`).addClass("float-label");
          } else {
            const inputId = $(e).attr("id");
            $(`label[for=${inputId}]`).removeClass("float-label");
          }
        });
      }
      handleAnimation();
      $(".field-animation input").on("change focus blur", handleAnimation);
    },
  };
})(jQuery, Drupal);
